var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhilippines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "148%",
    height: "148%",
    x: "-24%",
    y: "-24%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.723719175 0 0 0 0 0.723719175 0 0 0 0 0.723719175 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#a)",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M25 0v25L7.322 42.678A24.922 24.922 0 0 0 25 50c13.807 0 25-11.193 25-25S25 0 25 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M25 0A24.922 24.922 0 0 0 7.322 7.322L25 25h25C50 11.193 38.807 0 25 0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.118 25l-3.053-1.436 1.626-2.957-3.315.634-.42-3.35-2.31 2.464-2.31-2.463-.42 3.35-3.315-.635 1.626 2.957L2.174 25l3.053 1.436-1.626 2.957 3.316-.634.42 3.35 2.31-2.464 2.308 2.463.42-3.35 3.316.635-1.626-2.957zM6.667 9.783l1.016 1.42 1.665-.527L8.31 12.08l1.016 1.42-1.657-.552-1.037 1.405.013-1.746-1.656-.552 1.664-.527zM6.667 35.646l1.016 1.42 1.665-.527-1.037 1.405 1.016 1.42-1.657-.552-1.037 1.405.013-1.746-1.656-.552 1.664-.527zM21.159 22.714l-1.016 1.42-1.665-.527 1.037 1.405-1.016 1.42 1.657-.551 1.037 1.405-.013-1.746 1.657-.552-1.665-.528z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines);
export default __webpack_public_path__ + "static/media/philippines.f8d10cd08c83c161f4ff1a6d23f5beec.svg";
export { ForwardRef as ReactComponent };